import { PayloadAction } from '@reduxjs/toolkit';
import { IRootState } from './types';

const reducers = {
  setShiftDetails: (state: IRootState, action: PayloadAction<IRootState['shiftDetails']>) => ({
    ...state,
    shiftDetails: action.payload,
  }),
  setIsShiftStarted: (state: IRootState, action: PayloadAction<IRootState['isShiftStarted']>) => ({
    ...state,
    isShiftStarted: action.payload,
  }),
  setIsBreakStarted: (state: IRootState, action: PayloadAction<IRootState['isShiftStarted']>) => ({
    ...state,
    isBreakStarted: action.payload,
  }),
  setBreakIndex: (state: IRootState, action: PayloadAction<IRootState['breakIndex']>) => ({
    ...state,
    breakIndex: action.payload,
  }),
  setPersonnelStatus: (state: IRootState, action: PayloadAction<IRootState['personnelStatus']>) => ({
    ...state,
    personnelStatus: action.payload,
  }),
};

export {
  reducers,
};
